import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components";
import { useAppDispatch } from "@/redux/store";
import { setGruntAvailable, setGruntId } from "@/redux/profile/grunt/slice";
import { fetchGruntArenas } from "@/redux/profile/grunt/asyncAction";

import { IGruntItem } from "./types";
import datFormatterIso from "../getDateStringFormaterISO";
import Styles from "./GruntItem.module.scss";
const GruntItem: React.FC<IGruntItem> = (props) => {
  const navigate = useNavigate()

  const dispatch = useAppDispatch()
  const handleBtn = async (id: number) => {
    dispatch(setGruntId(id))
    dispatch(setGruntAvailable(true));
    dispatch(fetchGruntArenas(id))
    navigate(`/time-and-court`)
  }

  return(
    <>
      <div className={Styles.wrapper} >
        <div className={`${Styles.wrapper_header} ${Styles.wrapper_bold}`}>
          {datFormatterIso(props.data.date)}
        </div>
        <div className={`${Styles.wrapper_item}`}>
          <label>
            № Корта
          </label>
          <span className={`${Styles.wrapper_bold}`}>
            {props.data.court.title}
          </span>
        </div>
        <div className={`${Styles.wrapper_item}`}>
          <label>
            Время начала
          </label>
          <span className={`${Styles.wrapper_bold}`}>
            {props.data.time}
          </span>
        </div>
        <Button
          newStyles={Styles.btn}
          onClickFunc={() => handleBtn(props.data.id)}
        >
          Доплатить
        </Button>
      </div>
    </>
  )
}

export default GruntItem;
